<!--
  - Copyright (c) 2019. K+S France & Isagri Ingénierie
  - Ce composant gère la vue du formulaire de déterminition des besoins
  - SD version du 09/04/2019 15:36:54
  -->

<template>
  <v-container fluid class="page" transition="slide-x-transition">
  <div class="yield">
    <v-form v-model="valid" ref="yieldForm">
      <v-flex xs12 justify-center>
        <h1 class="form-title">{{$t("yield_title")}}</h1>
        <div class="contour">
          <v-select
              v-model="yieldObject.culture"
              :items="cultureList"
              item-text="culture"
              item-value="culture"
              color="#024EA1"
              ref="cultureInput"
              :label="$t('yield_form_culture_label')"
              single-line
              return-object
              :rules="[reglesRendement.culture]"
              @change="cultureSelected"
          >
          </v-select>
          <v-text-field
              v-model="yieldObject.yield"
              :label="$t('yield_form_yield_label')"
              :suffix="bornesRendement"
              clearable
              ref="yieldInput"
              id="yieldInput"
              type="number"
              color="#024EA1"
              :disabled="activeRendement"
              :rules="[reglesRendement.rendement]"
              @change="rendementSelected"
              @focus="$event.target.select()"
          ></v-text-field>
          <v-layout row nowrap justify-end>
            <v-btn dark small color="primary" class="btn-xs" @click="computeNeads" >{{ $t("yield_btn_calculer") }}</v-btn>
          </v-layout>
        </div>
      </v-flex>
    </v-form>
    <v-layout row wrap>
    </v-layout>
    <v-layout column mt-4 mb-4>
      <v-flex resultat xs12>
        <h1 class="form-title txt-center" v-html="titreBesoin"></h1>
        <div v-if="!displayNeads" class="txt-center">
          {{ $t("yield_neads_text") }}
        </div>

        <div class="besoins" v-if="displayNeads">
          <p class="petit txt-center" style="margin-top: -3em;">{{ $t("in_unit") | capitalize }}{{ $t("kgha") }}</p>
          <div class="ligne__elements">
            <div class="elem fadeInDown delay1" ><img src="img/elem_n.svg" alt="" class="icn"><span class="nead">{{ this.$store.state.formulaire.yield.neads.n | intLocal }}</span></div>
            <div class="elem fadeInDown delay2" ><img src="img/elem_p2o5.svg" alt="" class="icn"><span class="nead">{{ this.$store.state.formulaire.yield.neads.p2o5 | intLocal }}</span></div>
            <div class="elem fadeInDown delay3" ><img src="img/elem_k2o.svg" alt="" class="icn"><span class="nead">{{ this.$store.state.formulaire.yield.neads.k2o | intLocal }}</span></div>
          </div>
          <div class="ligne__elements">
            <div class="elem fadeInDown delay4" ><img src="img/elem_mgo.svg" alt="" class="icn"><span class="nead">{{ this.$store.state.formulaire.yield.neads.mgo | intLocal }}</span></div>
            <div class="elem fadeInDown delay5" ><img src="img/elem_so3.svg" alt="" class="icn"><span class="nead">{{ this.$store.state.formulaire.yield.neads.so3 | intLocal }}</span></div>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row nowrap justify-end>
      <v-btn color="primary" class="btn-ks white--text" :disabled="yieldOk" @click="nextScreen">{{ $t("btn_next") }}</v-btn>
    </v-layout>
  </div>
  </v-container>
</template>

<script>
// import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      name: "Yield",
      valid: false,
      yieldObject: {
        culture: false,
        yield: 0,
        neads: {}
      },
      yieldOk: true,
      firstLaunch: true,
      elem_animation: false,
      bornes: [0, 0],
      activeRendement: true,
      displayNeads: false,
      titreBesoin : this.$i18n.t("yield_nead_title"),
      reglesRendement: {
        culture: value => !!value || this.$i18n.t("yield_err_culture"),
        rendement: value => !!this.rendementValid(value) || this.$i18n.t("yield_err_bornes")
      }
    };
  },

  computed: {
    cultureList() {
      return this.$store.getters.getCulturesList;
    },

    bornesRendement() {
      if (!this.yieldObject.culture) {
        return "t/ha";
      } else {
        return `t/ha (${this.bornes[0]} min - ${this.bornes[1]} max)`;
      }
    }
  },

  methods: {
    cultureSelected(value) {
      // this.culture = this.$store.getters.getCulture(value);
      console.info("changement");
      this.bornes[0] = value.bornebasse;
      this.bornes[1] = value.bornehaute;
      this.activeRendement = false;
      if (this.firstLaunch) {
        this.firstLaunch = false;
      } else {
        this.yieldOk = !this.$refs.yieldForm.validate();
      }
      // pour la sélection automatique du textfield de rendement (focus)
      const elem = this.$el.querySelector('#yieldInput');
      if (elem) this.$nextTick(() => { elem.focus() });
      // this.$refs.yieldInput.focus();

    },

    rendementValid(value) {
      this.elem_animation = false;
      return value >= this.bornes[0] && value <= this.bornes[1];
    },

    computeNeads() {
      const valid = this.$refs.yieldForm.validate();
      if(valid) {
        this.rendementSelected(this.yieldObject.yield);
      }
    },

    btnNext() {
      console.info(this.$router.currentRoute);
    },

    rendementSelected() {
      //this.yieldObject.yield = parseFloat(value);
      this.yieldObject.yield = parseFloat(this.yieldObject.yield);

      if (this.rendementValid(this.yieldObject.yield)) {
        this.$store.dispatch("setYieldNeads", this.yieldObject).then(
          () => {
            this.displayNeads = true;
            this.yieldOk = false;
            // animation de l'apparition des résultats
            const elem = document.querySelectorAll('.elem');
            elem.forEach(e => e.classList.remove('animated', 'fadeInDown'));
            setTimeout(() =>
              elem.forEach(e => e.classList.add('animated', 'fadeInDown')), 10);
          },
          () => {
            console.error(
              this.$i18n.t("yield_err_calcul")
            );
            this.yieldOk = false;
          }
        );
      } // endif
    }, // rendementSelected
    nextScreen() {
      const valid = this.$refs.yieldForm.validate();

      if(valid) {
        this.$store.dispatch('updateRoutes', this.$router.currentRoute.path).then(
          () => {
            this.$router.push({path: 'apports'}); // on change de page
          },
          () => {
            console.error("Erreur de routage ")
          }
        )
      }
    }
  }, // fin des methodes
  mounted() {
    console.log("Yield Monté");
    if(this.$store.state.formulaire.yield.culture !== null ) {
      this.yieldObject.culture = this.$store.state.formulaire.yield.culture;
      this.cultureSelected(this.yieldObject.culture);
      this.yieldObject.yield = this.$store.state.formulaire.yield.yield;
      this.computeNeads();
      this.displayNeads = true;
      this.yieldOk = false;
    }
  }
};
</script>

<style lang="css">

  .besoins {
    margin-top: 2em;
  }

  .ligne__elements {
    display:flex;
    flex-flow: row wrap;
    justify-content: space-around;
    margin: 0 auto;
    width: 60%;
  }

  .elem {
    display:flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
  }
</style>
